import { defineMessages } from 'react-intl';

export const scope = 'app.components.proview_console_sessiond.sessions_table';

export default defineMessages({
  reviewed: {
    id: `${scope}.reviewed`,
    defaultMessage: 'Reviewed',
  },
  review_pending: {
    id: `${scope}.review_pending`,
    defaultMessage: 'Review Pending',
  },
  session_rating: {
    id: `${scope}.session_rating`,
    defaultMessage: 'Session Rating',
  },
  attendee: {
    id: `${scope}.attendee`,
    defaultMessage: 'Attendee',
  },
  exam: {
    id: `${scope}.exam`,
    defaultMessage: 'Exam',
  },
  proctoring_type: {
    id: `${scope}.proctoring_type`,
    defaultMessage: 'Proctoring Type',
  },
  accomodations: {
    id: `${scope}.accomodations`,
    defaultMessage: 'Accomodations',
  },
  provider: {
    id: `${scope}.provider`,
    defaultMessage: 'Provider',
  },
  attempt: {
    id: `${scope}.attempt`,
    defaultMessage: 'Attempt',
  },
  status: {
    id: `${scope}.status`,
    defaultMessage: 'Status',
  },
  reason: {
    id: `${scope}.reason`,
    defaultMessage: 'Reason',
  },
  summary: {
    id: `${scope}.summary`,
    defaultMessage: 'Summary',
  },
  session_duration: {
    id: `${scope}.session_duration`,
    defaultMessage: 'Session Duration',
  },
  external_id: {
    id: `${scope}.external_id`,
    defaultMessage: 'External ID',
  },
  completed_on: {
    id: `${scope}.completed_on`,
    defaultMessage: 'Completed On',
  },
  edit_request: {
    id: `${scope}.edit_request`,
    defaultMessage: 'Edit Request',
  },
});
